(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fc-erecta-hero"] && !Shopify.designMode) return;
  try {
    
(() => {

  const init = () => {

    const root = document.querySelector('[data-fc-product]');

    if (!root || root.dataset.initialized) return;

    window.fcErectaAbort?.abort();

    const eventController = new AbortController();

    window.fcErectaAbort = eventController;

    root.dataset.initialized = 'true';

    root.classList.add('fc-erecta-ready');

    document.addEventListener('click', event => {
      const link = event.target.closest('a[href]');
      if (!link || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
      const destination = new URL(link.href, location.href);
      if (destination.origin !== location.origin || decodeURIComponent(destination.pathname) !== decodeURIComponent(location.pathname) || destination.hash !== '#fc-erecta-pachete') return;
      const packages = root.querySelector('#fc-erecta-pachete');
      if (!packages) return;
      event.preventDefault();
      link.closest('.fc-site-menu')?.removeAttribute('open');
      const currentURL = new URL(location.href);
      currentURL.hash = destination.hash;
      history.replaceState(history.state, '', currentURL.href);
      let offset = 16;
      document.querySelectorAll('header,.fc-site-header,.fc-erecta-navigation').forEach(header => {
        const style = getComputedStyle(header);
        if (style.position === 'fixed') offset = Math.max(offset, header.getBoundingClientRect().bottom + 16);
        if (style.position === 'sticky') offset = Math.max(offset, (parseFloat(style.top) || 0) + header.getBoundingClientRect().height + 16);
      });
      const heading = packages.querySelector('h2') || packages;
      const tabindex = heading.getAttribute('tabindex');
      if (tabindex === null) heading.setAttribute('tabindex', '-1');
      heading.focus({preventScroll:true});
      if (tabindex === null) heading.addEventListener('blur', () => heading.removeAttribute('tabindex'), {once:true});
      window.scrollTo({
        top: Math.max(0, window.scrollY + packages.getBoundingClientRect().top - offset),
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
    }, {signal:eventController.signal});


    const variants = JSON.parse(root.querySelector('[data-fc-variants]').textContent);

    const form = root.querySelector('form');

    const select = form.querySelector('[data-fc-id]');

    const ds = root.dataset;

    const all = s => [...document.querySelectorAll(s)];

    const money = value => ds.currency === 'RON' ? `${new Intl.NumberFormat('ro-RO',{minimumFractionDigits:2,maximumFractionDigits:2}).format(value/100)} lei` : new Intl.NumberFormat(ds.locale || 'ro-RO', { style:'currency', currency:ds.currency || 'RON' }).format(value/100);

    let current = variants.find(v => String(v.id) === ds.initialVariant) || variants[0];

    let busy = false;

    const price = () => current.price;
    const available = () => current.available;

    const track = event => {
      try {
        if (window.Shopify?.designMode) return;
        const consent = window.Shopify?.customerPrivacy;
        if (typeof consent?.analyticsProcessingAllowed !== 'function' || consent.analyticsProcessingAllowed() !== true) return;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event, lp_variant:ds.fcScheme, ecommerce:{ currency:ds.currency, value:price()/100, items:[{item_id:ds.productId,item_name:ds.productTitle,item_variant:current.title,price:current.price/100,quantity:1}] } });
      } catch {}
    };
    function update(rebuildPlans = true) {

      select.value = String(current.id);

      all('[data-fc-variant]').forEach(el => el.setAttribute('aria-pressed',String(el.dataset.fcVariant === String(current.id))));

      root.querySelectorAll('[data-fc-buy-variant]').forEach(button => {
        const variant = variants.find(v => String(v.id) === button.dataset.fcBuyVariant);
        button.disabled = busy || !variant?.available;
        button.querySelector('span').textContent = busy && variant?.id === current.id ? ds.loading : variant?.available ? ds.buy : ds.soldOut;
      });
      root.querySelectorAll('[data-package-card]').forEach(card => {
        const selected = card.dataset.packageCard === String(current.id);
        card.classList.toggle('is-selected', selected);
        const badge = card.querySelector('[data-package-selected]');
        if (badge) badge.hidden = !selected;
      });

      all('[data-fc-add],[data-fc-main-cta]').forEach(el => el.disabled = busy || !available());

      const card = root.querySelector(`[data-fc-variant="${current.id}"]`);

      root.querySelector('[data-fc-selected-title]').textContent = card?.querySelector('strong')?.textContent || current.title;

      root.querySelector('[data-fc-selected-price]').textContent = money(price());

    }

    function choose(id, push = true) {

      const next = variants.find(v => String(v.id) === String(id));

      if (!next) return;

      current = next; update();

      if (push) { const url = new URL(location.href); url.searchParams.set('variant',current.id); history.replaceState({},'',url);track('select_item'); }

    }

    document.addEventListener('click', e => {

      const variant = e.target.closest('[data-fc-variant]');

      if (variant && !variant.disabled) choose(variant.dataset.fcVariant);

      if (e.target.closest('[data-fc-add]')) form.requestSubmit(root.querySelector(`[data-fc-buy-variant="${current.id}"]`));

    }, {signal:eventController.signal});

    select.addEventListener('change',() => choose(select.value));

    window.addEventListener('popstate',() => choose(new URL(location.href).searchParams.get('variant') || ds.initialVariant,false), {signal:eventController.signal});

    const slides = [...root.querySelectorAll('[data-fc-slide]')];

    let active = 0;

    function go(index) {

      if (!slides.length) return;

      active = (index + slides.length) % slides.length;

      slides.forEach((el,i) => {el.hidden = i !== active; if (i !== active) el.querySelector('video')?.pause();});

      root.querySelectorAll('[data-fc-thumb]').forEach((el,i) => {el.setAttribute('aria-pressed',String(i === active));if (i === active) el.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth',block:'nearest',inline:'nearest'});});

      const counter = root.querySelector('[data-fc-counter]');if(counter)counter.textContent = `${active+1} / ${slides.length}`;

    }

    root.querySelector('[data-fc-prev]')?.addEventListener('click',() => go(active-1));

    root.querySelector('[data-fc-next]')?.addEventListener('click',() => go(active+1));

    root.querySelectorAll('[data-fc-thumb]').forEach(el => el.addEventListener('click',() => go(Number(el.dataset.fcThumb))));

    let touchX = 0;

    const stage = root.querySelector('.fc-erecta-stage');

    stage.addEventListener('touchstart',e => touchX = e.changedTouches[0].clientX,{passive:true});

    stage.addEventListener('touchend',e => {const dx=e.changedTouches[0].clientX-touchX;if(Math.abs(dx)>50)go(active+(dx<0?1:-1));},{passive:true});

    const message = root.querySelector('[data-fc-message]');

    const toast = root.querySelector('[data-fc-toast]');

    root.querySelector('[data-fc-toast-close]').addEventListener('click',() => toast.hidden=true);

    form.addEventListener('submit',async e => {

      e.preventDefault();e.stopImmediatePropagation();

      if (busy) return;
      if (e.submitter?.dataset.fcBuyVariant) choose(e.submitter.dataset.fcBuyVariant);
      if (!available()) return;

      busy=true;update(false);message.textContent='';


      const item = {id: current.id, quantity: 1};
      const items = [item];
      try {
        const response = await fetch(ds.addUrl,{method:'POST',body:JSON.stringify({items}),headers:{Accept:'application/json','Content-Type':'application/json'}});
        const result = await response.json();
        if(!response.ok || result.status) throw new Error(result.description || result.message || ds.error);
        track('add_to_cart');
        const destination = new URL(ds.cartUrl,location.origin);
        const currentURL = new URL(location.href);
        for (const key of ['preview_theme_id','_fd','pb']) if(currentURL.searchParams.has(key)) destination.searchParams.set(key,currentURL.searchParams.get(key));
        location.assign(destination.href);

      } catch(error){message.textContent=error.message || ds.error;message.scrollIntoView({block:'nearest'});}

      finally{busy=false;update(false);}

    },true);

    root.querySelectorAll('.fc-bundle-form').forEach(bundleForm => {
      let adding = false;
      const button = bundleForm.querySelector('button[type="submit"]');
      const label = button.querySelector('span');
      const message = bundleForm.querySelector('[role="status"]');
      const initialLabel = label.textContent;
      bundleForm.addEventListener('submit', async event => {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (adding || button.disabled) return;
        adding = true;
        button.disabled = true;
        label.textContent = ds.loading;
        message.textContent = '';
        try {
          const id = Number(bundleForm.querySelector('[name="id"]').value);
          const response = await fetch(ds.addUrl, {method:'POST', headers:{Accept:'application/json','Content-Type':'application/json'}, body:JSON.stringify({items:[{id,quantity:1}]})});
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || result.message || ds.error);
          const destination = new URL(ds.cartUrl, location.origin);
          const currentURL = new URL(location.href);
          for (const key of ['preview_theme_id','_fd','pb']) if (currentURL.searchParams.has(key)) destination.searchParams.set(key,currentURL.searchParams.get(key));
          location.assign(destination.href);
        } catch (error) {
          message.textContent = error.message || ds.error;
          message.scrollIntoView({block:'nearest'});
        } finally {
          adding = false;
          button.disabled = false;
          label.textContent = initialLabel;
        }
      }, {capture:true,signal:eventController.signal});
    });

    const main = form;

    const sticky=root.querySelector('[data-fc-sticky]');

    let stickyFrame = 0;

    const updateSticky = () => { stickyFrame=0;sticky.hidden=main.getBoundingClientRect().bottom>0; };

    const queueSticky = () => { if(!stickyFrame)stickyFrame=requestAnimationFrame(updateSticky); };

    window.addEventListener('scroll',queueSticky,{passive:true,signal:eventController.signal});

    window.addEventListener('resize',queueSticky,{passive:true,signal:eventController.signal});

    updateSticky();

    all('[data-fc-ingredient]').forEach(el=>{

      const highlight=active=>all('[data-fc-ingredient]').forEach(item=>item.classList.toggle('fc-erecta-active',active && item.dataset.fcIngredient===el.dataset.fcIngredient));

      el.addEventListener('mouseenter',()=>highlight(true));el.addEventListener('mouseleave',()=>highlight(false));el.addEventListener('focus',()=>highlight(true));el.addEventListener('blur',()=>highlight(false));

    });

    const refreshDelivery = () => all('[data-fc-eta]').forEach(el => {
      const parts = new Intl.DateTimeFormat('en-GB', {timeZone:'Europe/Bucharest',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',hourCycle:'h23'}).formatToParts(new Date());
      const get = t => Number(parts.find(p => p.type === t).value);
      const today = new Date(Date.UTC(get('year'),get('month')-1,get('day'),12));
      const ship = new Date(today);
      const excluded = [...new Set((el.dataset.excluded || '').split(',').filter(v => v.trim() !== '').map(Number).filter(d => d >= 0 && d <= 6))];
      const holidays = (el.dataset.holidays || '').split(/[\s,;]+/).filter(Boolean);
      const blocked = date => excluded.includes(date.getUTCDay()) || holidays.includes(date.toISOString().slice(0,10));
      const cutoff = Math.min(23,Math.max(0,Number(el.dataset.cutoff) || 14));
      const minutesLeft = cutoff * 60 - get('hour') * 60 - get('minute');
      if (minutesLeft <= 0) ship.setUTCDate(ship.getUTCDate()+1);
      let attempts = 0;
      while (blocked(ship) && attempts++ < 370) ship.setUTCDate(ship.getUTCDate()+1);
      if (attempts >= 370) { el.hidden = true; return; }
      el.hidden = false;
      const after = days => {
        const date = new Date(ship);
        for (let n=0,guard=0; n<days && guard<730; guard++) {
          date.setUTCDate(date.getUTCDate()+1);
          if (!blocked(date)) n++;
        }
        return date;
      };
      const min = Math.min(60,Math.max(0,Number(el.dataset.min) || 0));
      const max = Math.min(60,Math.max(min,Number(el.dataset.max) || min));
      const fmt = new Intl.DateTimeFormat('ro-RO',{day:'numeric',month:'long',timeZone:'UTC'});
      const sameDay = ship.getTime() === today.getTime();
      el.querySelector('[data-fc-eta-order]').textContent = sameDay ? `Comanzi azi până la ${String(cutoff).padStart(2,'0')}:00` : 'Comanzi acum';
      el.querySelector('[data-fc-eta-countdown]').textContent = sameDay ? `Mai ai ${Math.floor(minutesLeft/60)} h ${minutesLeft%60} min ca să plece azi` : `Expediere estimată: ${fmt.format(ship)}`;
      const first=after(min), last=after(max);
      el.querySelector('[data-fc-eta-range]').textContent = first.getTime()===last.getTime() ? fmt.format(first) : `${fmt.format(first)} – ${fmt.format(last)}`;
    });
    refreshDelivery();
    const deliveryTimer = setInterval(refreshDelivery,30000);
    eventController.signal.addEventListener('abort',()=>clearInterval(deliveryTimer),{once:true});

    root.fcUpdate = update;

    update();track('view_item');

  };

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();

  document.addEventListener('shopify:section:load',() => { init();document.querySelector('[data-fc-product]')?.fcUpdate?.(false); });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-erecta-story"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initStory(scope=document) {
    scope.querySelectorAll('[data-fc-story]').forEach(root => {
      if(root.dataset.storyReady) return;
      root.dataset.storyReady='true';
      const track=root.querySelector('[data-story-track]');
      const controls=root.querySelector('[data-story-controls]');
      const prev=root.querySelector('[data-story-prev]');
      const next=root.querySelector('[data-story-next]');
      if(track) {
        const sync=()=>{controls.hidden=track.scrollWidth<=track.clientWidth+2;prev.disabled=track.scrollLeft<=2;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;};
        const move=direction=>{const card=track.firstElementChild;if(!card)return;track.scrollBy({left:direction*(card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).columnGap)),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});};
        prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));track.addEventListener('scroll',sync,{passive:true});
        const observer=new ResizeObserver(sync);observer.observe(track);root.storyCleanup=()=>observer.disconnect();sync();
      }
      root.querySelector('[data-story-cta]')?.addEventListener('click',event=>{
        const link=event.currentTarget;
        if(link.dataset.action==='product'||link.dataset.action==='custom'||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||event.button!==0)return;
        let target=document.querySelector('[data-fc-product]');
        if(link.dataset.action==='next') {target=root.closest('.shopify-section').nextElementSibling;while(target&&(!target.getClientRects().length||target.getBoundingClientRect().height===0||!target.textContent.trim()&&!target.querySelector('img,video,iframe')))target=target.nextElementSibling;}
        if(!target)return;
        event.preventDefault();
        let offset=16;document.querySelectorAll('header,.fc-site-header,.fc-erecta-navigation').forEach(el=>{const style=getComputedStyle(el);if(style.position==='sticky'||style.position==='fixed')offset=Math.max(offset,el.getBoundingClientRect().height+16);});
        const heading=target.querySelector('h1,h2')||target;heading.setAttribute('tabindex','-1');heading.focus({preventScroll:true});
        window.scrollTo({top:window.scrollY+target.getBoundingClientRect().top-offset,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
      });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initStory());else initStory();
  document.addEventListener('shopify:section:load',event=>initStory(event.target));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-fc-story]').forEach(root=>root.storyCleanup?.()));
  document.addEventListener('shopify:block:select',event=>{const card=event.target.closest('.fc-story__card');const track=card?.closest('[data-story-track]');if(track&&matchMedia('(min-width:750px)').matches)track.scrollTo({left:card.offsetLeft-track.firstElementChild.offsetLeft,behavior:'instant'});});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-erecta-testimonials"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fc-review-carousel')) {
  customElements.define('fc-review-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.fc-testimonials__track');
      this.cards = [...this.querySelectorAll('.fc-testimonials__card')];
      this.previous = this.querySelector('[data-previous]');
      this.next = this.querySelector('[data-next]');
      this.position = this.querySelector('[data-position]');
      if (!this.track || !this.cards.length) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }, { ...options, passive: true });
      this.track.addEventListener('keydown', (event) => {
        if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.move(event.key === 'ArrowRight' ? 1 : -1);
      }, options);
      this.addEventListener('shopify:block:select', (event) => {
        const card = event.target.closest('.fc-testimonials__card');
        if (card) this.track.scrollTo({ left: card.offsetLeft - this.cards[0].offsetLeft, behavior: 'instant' });
      }, options);
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      this.setAttribute('data-ready', '');
      this.update();
    }
    move(direction) {
      const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
      const step = this.cards[0].getBoundingClientRect().width + gap;
      const index = Math.round(this.track.scrollLeft / step);
      this.track.scrollTo({ left: (index + direction) * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    update() {
      const left = this.track.scrollLeft;
      this.previous.disabled = left <= 2;
      this.next.disabled = left >= this.track.scrollWidth - this.track.clientWidth - 2;
      const bounds = this.track.getBoundingClientRect();
      const visible = this.cards.map((card, index) => ({ rect: card.getBoundingClientRect(), index })).filter(({ rect }) => rect.left >= bounds.left - 2 && rect.right <= bounds.right + 2);
      if (visible.length) this.position.textContent = visible.length > 1 ? `${visible[0].index + 1}–${visible[visible.length - 1].index + 1}` : `${visible[0].index + 1}`;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-site-header"]) return;
  try {
    
const applyHeaderScheme = () => {
  const scheme = document.documentElement.dataset.fcScheme === 'light' ? 'light' : 'dark';
  document.documentElement.style.colorScheme = scheme;
  document.querySelectorAll('.fc-erecta[data-fc-scheme]').forEach(element => element.dataset.fcScheme = scheme);
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyHeaderScheme);
else applyHeaderScheme();
document.addEventListener('shopify:section:load', applyHeaderScheme);
document.addEventListener('click', event => {
  if (event.target.closest('.fc-site-mobile-nav a')) {
    document.querySelector('.fc-site-menu')?.removeAttribute('open');
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iframe-video"]) return;
  try {
    
	const postervideo = document.querySelector('[id^="Deferred-Poster-"]');
    postervideo.addEventListener('click', function(){
        if (!this.getAttribute('loaded')) {
          const content = document.createElement('div');
          content.appendChild(this.nextElementSibling.content.firstElementChild.cloneNode(true));
          this.parentElement.setAttribute('loaded', true);
          this.parentElement.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
        }
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"]) return;
  try {
    
    jQuery(document).ready(function ($) {
        $('.btn-close').on('click', function(){
        $(this).parents('.parent-close').slideUp();
        })
    });

  } catch(e) { console.error(e); }
})();
})();
